import { memo } from 'react';

import SortIconSVG from '@/assets/sort-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ISortIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={SortIconSVG} {...props} />;

export const SortIcon = memo(ISortIcon) as typeof ISortIcon;
